<div class="container w-100">
    <div *ngIf="!isCreateUser && isDisplayPage">
        <div class="Tabletitle">
            <span> Users configured:
                <span *ngIf="allUsers">
                    ({{usersCount}})
                </span>
            </span>
        </div>
        <div class="filtercontainer">
            <!-- <button mat-raised-button class="actionButton" (click)="createUser()">Add User</button> -->
            <mat-form-field class="element-filter">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)">
            </mat-form-field>
        </div>

        <div class="table-container mat-elevation-z8" *ngIf="!isViewGroup">
            <table aria-describedby="users-table" mat-table matSort [dataSource]="allUsers" matSortActive="name"
                matSortDirection="asc">

                <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition"-->

                <!-- Hold Name Column -->
                <ng-container matColumnDef="username">
                    <th id="username" mat-header-cell *matHeaderCellDef mat-sort-header> Username </th>
                    <td mat-cell *matCellDef="let user"> {{user.Username}} </td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th id="email" mat-header-cell *matHeaderCellDef mat-sort-header> Email ID </th>
                    <td mat-cell *matCellDef="let user">
                        <span *ngFor="let attr of user.Attributes">
                            <span *ngIf="attr.Name == 'email'">{{attr.Value}}</span>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="phonenumber">
                    <th id="phoneNumber" mat-header-cell *matHeaderCellDef mat-sort-header> Phone No. </th>
                    <td mat-cell *matCellDef="let user">
                        <span *ngFor="let attr of user.Attributes">
                            <span *ngIf="attr.Name == 'phone_number'">{{attr.Value}}</span>
                        </span>
                    </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="actions">
                    <th id="actions" mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                    <td mat-cell *matCellDef="let user">
                        <mat-icon title="View User Groups" (click)="openViewGroupsDialog(user)">visibility</mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
        </div>
    </div>

    <div *ngIf="isCreateUser && !isDisplayPage">
        <div class="Tabletitle">Create User</div>
        <div class="card-body" *ngIf="!isUserCreated">
            <form [formGroup]="userForm">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Username</span>
                    </div>
                    <input type="text" class="form-control" id="username" name="username" formControlName="username">
                </div>
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Email address</span>
                    </div>
                    <input type="email" placeholder="example@mail.com" class="form-control" id="email" name="email"
                        formControlName="email">
                </div>
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Password</span>
                    </div>
                    <input [type]="hide ? 'password' : 'text'" class="form-control" id="password" name="password"
                        formControlName="password">
                    <mat-icon matSuffix style="position: relative; top: 3px; margin-left: 2px;" (click)="hide = !hide">
                        {{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                </div>
                <!-- <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Confirm Password</span>
                    </div>
                    <input [type]="hide ? 'password' : 'text'" onblur="passwordMatchCheck()" class="form-control"
                        id="confirm password" name="confirm password" formControlName="confirmPassword">
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </div> -->

                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">First Name</span>
                    </div>
                    <input type="text" class="form-control" id="firstname" name="firstname" formControlName="firstname">
                </div>

                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Last Name</span>
                    </div>
                    <input type="text" class="form-control" id="lastname" name="lastname" formControlName="lastname">
                </div>

                <div class="button-class">
                    <button mat-raised-button class="actionButton m-3" (click)="saveUser()" [disabled]="!userForm.valid"
                        mat-button>Create</button>
                    <button mat-raised-button class="backButton m-2" (click)="displayPage()" mat-button>Back</button>
                </div>
            </form>
        </div>
        <div *ngIf="isUserCreated" class=card-body>
            <strong>{{this.userForm.value.firstname}} {{this.userForm.value.lastname}}</strong> has been created.
            <button mat-raised-button class="backButton m-2" (click)="displayPage()" mat-button>Close</button>
        </div>
    </div>
</div>